(function () {
  var header = document.querySelector("[data-header]");
  function markStuck() {
    if (!header) return;
    header.classList.toggle("is-stuck", window.scrollY > 8);
  }
  markStuck();
  window.addEventListener("scroll", markStuck, { passive: true });

  var nav = document.querySelector("[data-mobile-nav]");
  document.addEventListener("click", function (event) {
    var t = event.target;
    if (!(t instanceof Element)) return;
    if (t.closest("[data-menu-open]") && nav) nav.hidden = false;
    if (t.closest("[data-menu-close]") && nav) nav.hidden = true;

    var thumb = t.closest("[data-thumb]");
    if (thumb) {
      var root = thumb.closest("[data-product]");
      if (!root) return;
      var id = thumb.getAttribute("data-thumb");
      root.querySelectorAll("[data-media-id]").forEach(function (img) {
        img.classList.toggle("is-hidden", img.getAttribute("data-media-id") !== id);
      });
    }

    if (t.closest("[data-cart-open]")) {
      event.preventDefault();
      openCart();
    }
    if (t.closest("[data-cart-close]") || t.matches("[data-cart-backdrop]")) closeCart();

    var qtyBtn = t.closest("[data-qty]");
    if (qtyBtn) {
      var input = qtyBtn.parentElement && qtyBtn.parentElement.querySelector("input[name='quantity']");
      if (!input) return;
      var next = parseInt(input.value || "1", 10) + parseInt(qtyBtn.getAttribute("data-qty") || "0", 10);
      input.value = String(Math.max(1, next));
    }
  });

  document.addEventListener("change", function (event) {
    var t = event.target;
    if (!(t instanceof Element) || !t.matches("[data-option]")) return;
    var root = t.closest("[data-product]");
    if (!root) return;
    var holder = root.querySelector("[data-variants]");
    if (!holder) return;
    var variants = JSON.parse(holder.textContent || "[]");
    var chosen = {};
    root.querySelectorAll("[data-option]:checked").forEach(function (input) {
      chosen[input.getAttribute("data-option-name")] = input.value;
    });
    var match = variants.find(function (v) {
      return (v.options || []).every(function (value, index) {
        return chosen["option" + (index + 1)] === value;
      });
    });
    if (!match) return;
    var idInput = root.querySelector("input[name='id']");
    if (idInput) idInput.value = match.id;
    var price = root.querySelector("[data-price]");
    if (price) price.textContent = format(match.price);
    var btn = root.querySelector("[data-atc]");
    if (btn) {
      btn.disabled = !match.available;
      btn.textContent = match.available ? btn.getAttribute("data-label") || "Add to cart" : "Sold out";
    }
    if (match.featured_image && match.featured_image.id) {
      root.querySelectorAll("[data-media-id]").forEach(function (img) {
        img.classList.toggle("is-hidden", img.getAttribute("data-media-id") !== String(match.featured_image.id));
      });
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-product-form], .product-form")) return;
    event.preventDefault();
    var endpoint = (window.theme && window.theme.cartAdd) || "/cart/add";
    fetch(endpoint + ".js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        return res.json();
      })
      .then(function () {
        openCart();
      })
      .catch(function () {
        form.submit();
      });
  });

  var atc = document.querySelector("[data-atc]");
  var bar = document.querySelector("[data-sticky-atc]");
  if (atc && bar && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle("is-on", !entry.isIntersecting);
      });
    });
    io.observe(atc);
  }

  function format(cents) {
    var currency = (window.theme && window.theme.currency) || "USD";
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (ch) {
      if (ch === "&") return "&" + "amp;";
      if (ch === "<") return "&" + "lt;";
      if (ch === ">") return "&" + "gt;";
      if (ch === '"') return "&" + "quot;";
      return "&" + "#39;";
    });
  }

  function openCart() {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.hidden = false;
    refreshCart();
  }
  function closeCart() {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (drawer) drawer.hidden = true;
  }

  function refreshCart() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.querySelector("[data-cart-count]");
        if (count) count.textContent = String(cart.item_count || 0);
        var body = document.querySelector("[data-cart-items]");
        var sub = document.querySelector("[data-cart-subtotal]");
        if (sub) sub.textContent = format(cart.total_price || 0);
        if (!body) return;
        if (!cart.items || !cart.items.length) {
          body.innerHTML = '<p class="muted">The cart is empty.</p>';
          return;
        }
        body.innerHTML = cart.items
          .map(function (item) {
            var img = item.image ? '<img src="' + esc(item.image) + '" alt="">' : "";
            return (
              '<div class="cart-line">' +
              img +
              '<div><a href="' + esc(item.url) + '">' + esc(item.product_title) + "</a>" +
              "<p>" + format(item.final_price) + "</p>" +
              '<button type="button" data-line="' + esc(item.key) + '" data-line-qty="' + (item.quantity - 1) + '">−</button> ' +
              item.quantity +
              ' <button type="button" data-line="' + esc(item.key) + '" data-line-qty="' + (item.quantity + 1) + '">+</button></div></div>'
            );
          })
          .join("");
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (event) {
    var t = event.target;
    if (!(t instanceof Element)) return;
    var lineBtn = t.closest("[data-line]");
    if (!lineBtn) return;
    var key = lineBtn.getAttribute("data-line");
    var qty = lineBtn.getAttribute("data-line-qty");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(qty) }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); });
  });

  document.addEventListener("shopify:section:load", markStuck);

  var promo = document.querySelector("[data-promo]");
  if (promo && !sessionStorage.getItem("hh-promo")) {
    promo.hidden = false;
  }
  document.addEventListener("click", function (event) {
    var t = event.target;
    if (!(t instanceof Element) || !promo) return;
    if (t.closest("[data-promo-close]")) {
      promo.hidden = true;
      sessionStorage.setItem("hh-promo", "1");
    }
  });
})();
